import { render, staticRenderFns } from "./GetAddressModal.vue?vue&type=template&id=18fa2169"
import script from "./GetAddressModal.vue?vue&type=script&lang=js"
export * from "./GetAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports